import {
  AccountType,
  type MeCurrentMembershipDto,
  type SupplierOnboardingStatusDto,
} from '@paladin-monorepo/common';

export type MeUserForOnboarding = {
  account?: { accountType?: string };
  currentMembership?: MeCurrentMembershipDto | null;
  supplierOnboarding?: SupplierOnboardingStatusDto;
};

export function userNeedsSupplierOnboarding(
  user: MeUserForOnboarding | null | undefined,
): boolean {
  if (!user?.currentMembership) return false;
  const t = user.account?.accountType;
  if (t !== AccountType.Consultant && t !== AccountType.SolutionProvider) {
    return false;
  }
  return user.currentMembership.supplierOnboardingCompletedAt == null;
}

/** Apply immediately after POST /me/onboarding so redirect gate sees completed state. */
export function withSupplierOnboardingCompleted<T extends MeUserForOnboarding>(
  user: T,
): T {
  if (!user.currentMembership) return user;
  const completedAt = new Date().toISOString();
  return {
    ...user,
    currentMembership: {
      ...user.currentMembership,
      supplierOnboardingCompletedAt: completedAt,
    },
    supplierOnboarding: {
      needsSupplierOnboarding: false,
      showAccountLocationStep: false,
    },
  };
}
